import { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';

const navLinks = [
  { to: '/', label: '首页' },
  { to: '/community', label: '讨论社区' },
  { to: '/topics', label: '专题' },
  { to: '/about', label: '关于我们' },
  { to: '/faq', label: '常见问题' },
  { to: '/contact', label: '联系我们' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || open
          ? 'bg-background-50/90 backdrop-blur-md shadow-sm border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <nav className="mx-auto flex w-full max-w-7xl items-center justify-between px-4 md:px-6 py-3.5">
        <Link to="/" className="flex items-center gap-2 group">
          <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-background-50">
            <i className="ri-sparkling-fill text-lg"></i>
          </span>
          <span className="font-heading text-xl md:text-2xl tracking-wide">
            羞羞动漫社
          </span>
        </Link>

        <ul className="hidden md:flex items-center gap-1">
          {navLinks.map((l) => (
            <li key={l.to}>
              <NavLink
                to={l.to}
                className={({ isActive }) =>
                  `rounded-md px-3.5 py-2 text-sm transition-colors ${
                    isActive
                      ? 'bg-primary-100 text-primary-700 font-semibold'
                      : 'text-foreground-700 hover:text-primary-700 hover:bg-background-100'
                  }`
                }
              >
                {l.label}
              </NavLink>
            </li>
          ))}
        </ul>

        <div className="flex items-center gap-2">
          <Link
            to="/community"
            className="hidden md:inline-flex whitespace-nowrap items-center gap-1.5 rounded-md bg-primary-500 text-background-50 px-4 py-2 text-sm font-semibold hover:bg-primary-600 transition-colors"
          >
            <i className="ri-chat-smile-3-fill"></i>
            加入社区
          </Link>
          <button
            type="button"
            aria-label="切换菜单"
            onClick={() => setOpen((v) => !v)}
            className="md:hidden flex h-10 w-10 items-center justify-center rounded-md bg-background-100 text-foreground-800"
          >
            <i className={`${open ? 'ri-close-line' : 'ri-menu-line'} text-xl`}></i>
          </button>
        </div>
      </nav>

      {open && (
        <div className="md:hidden border-t border-background-200/70 bg-background-50/95 backdrop-blur-md px-4 pb-4">
          <ul className="flex flex-col pt-2 gap-1">
            {navLinks.map((l) => (
              <li key={l.to}>
                <NavLink
                  to={l.to}
                  className={({ isActive }) =>
                    `block rounded-md px-3 py-2.5 text-sm ${
                      isActive
                        ? 'bg-primary-100 text-primary-700 font-semibold'
                        : 'text-foreground-800 hover:bg-background-100'
                    }`
                  }
                >
                  {l.label}
                </NavLink>
              </li>
            ))}
            <li className="pt-2">
              <Link
                to="/community"
                className="flex whitespace-nowrap items-center justify-center gap-1.5 rounded-md bg-primary-500 text-background-50 px-4 py-2.5 text-sm font-semibold"
              >
                <i className="ri-chat-smile-3-fill"></i>
                加入社区
              </Link>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
}